import {createAsyncThunk,createSlice} from "@reduxjs/toolkit";

const initialState={
    paymentList:[],
    selectedPayment:null,
    status:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}
export const fetchPayments=createAsyncThunk('payment/fetchPayments', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/payment/getAllPayments',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const makePayment=createAsyncThunk('payment/makePayment', async (paymentData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/api/checkout/create-session',
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(paymentData)
        }
    )
    return response.json()
})

export const paymentSlice=createSlice({
    name:'payment',
    initialState,
    reducers:{},
    extraReducers:(builder)=>{
        builder
            .addCase(fetchPayments.pending,(state)=>{
                state.status='loading';
            })
            .addCase(fetchPayments.fulfilled,(state,action)=>{
                state.status='succeeded';
                state.paymentList=action.payload;
            })
            .addCase(fetchPayments.rejected,(state,action)=>{
                state.status='failed';
                state.error=action.error.message;
            })
            .addCase(makePayment.pending,(state)=>{
                state.registerstatus='loading';
            })
            .addCase(makePayment.fulfilled,(state,action)=>{
                state.registerstatus='succeeded';
                state.selectedPayment=action.payload;
            })
            .addCase(makePayment.rejected,(state,action)=>{
                state.registerstatus='failed';
                state.error=action.error.message;
            })
    }
})

export default paymentSlice.reducer;